import React, { useState } from "react";
import { InputForm } from "../../_helpers/components/Forms/InputLabel";
import { Button } from "../../_helpers/components/Button";
import { AskResetPassword } from "../../_api/Admin";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import logo from "../../../../../public/imgs/logo.png";
import { test } from "../../Layout/ClientDescription";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    const resetPassword = (e) => {
        e?.preventDefault?.();
        setIsSubmitting(true);
        AskResetPassword({ email })
            .then((resp) => {
                toast(resp.data.message);
                setEmail("");
                navigate('/');
            })
            .catch((resp) => {
                toast(resp.response.data.message);
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    const hostname = window.location.hostname;
    const sub_domain = hostname.includes("localhost") ? "" : hostname.split(".")[0];

    return (
        <>
            <div className="w-full lg:w-1/2 flex justify-center items-center">
                {" "}
                <div className="bg-white p-10 rounded-lg shadow-md w-3/4 max-w-md">
                    <div className="lg:hidden w-full h-48 mb-4">
                        <img
                            src={test[sub_domain]?.logo || logo}
                            alt="Logo"
                            onClick={() => navigate("/")}
                            className="w-full h-full object-cover cursor-pointer"
                        />
                    </div>
                    <h4 className="italic">
                        Renouveler votre mot de passe.
                    </h4>
                    <form className="space-y-4">
                        <InputForm
                            name="Email"
                            value={email}
                            placeholder={"exemple@domaine.fr"}
                            set={setEmail}
                            required={true}
                        />

                        <div className="flex justify-end">
                            <Button
                                name={"Demander un nouveau mot de passe"}
                                action={(e) => {
                                    e.preventDefault();
                                    resetPassword(e);
                                }}
                                loading={isSubmitting}
                            />
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default ForgotPassword;
